var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',[_c('v-alert',{staticClass:"font-weight-medium",attrs:{"type":"error","border":"left","colored-border":"","elevation":"2"}},[_vm._v(_vm._s(_vm.message))])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }